import React from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";

import "./UserProfile.scss";
import ProfileCard from "../../components/UserProfile/ProfileCard/ProfileCard";
import profilePic from "../../assets/icons/header/profile_pic.png";
import { notify } from "../../components/Notify/Notify";

export default class UserProfile extends React.Component {
  state = {
    userInformation: {
      profilePic: profilePic,
      firstName: "",
      lastName: "",
      email: "",
      mobileNo: "",
    },
    // preferences: {
    //   languages: ["English (US)", "German"],
    //   timeZones: ["Chicago (GMT-5)", "IST (GMT+5:30)"],
    //   dateFormat: ["MM/DD/YYYY", "DD/MMM/YYYY"],
    // },
    emailSettings: [],
    notificationSettings: [],
    emailSelectAll: false,
    notifySelectAll: false,
  };

  setValuesOfSettings = (NotificationSettings) => {
    let emailSettings = [
      {
        id: "fileAddedEmail",
        label: "New file is added",
        value: NotificationSettings.fileAddedEmail,
      },
      {
        id: "fileEditedEmail",
        label: "File is edited",
        value: NotificationSettings.fileEditedEmail,
      },
      {
        id: "fileDeletedEmail",
        label: "File is deleted",
        value: NotificationSettings.fileDeletedEmail,
      },
      {
        id: "fileArchivedEmail",
        label: "File is archived",
        value: NotificationSettings.fileArchivedEmail,
      },
      {
        id: "fileMovedEmail",
        label: "File is Moved",
        value: NotificationSettings.fileMovedEmail,
      },
      {
        id: "fileSharedMeEmail",
        label: "Files shared with me",
        value: NotificationSettings.fileSharedMeEmail,
      },
      {
        id: "fileSharedSomeoneEmail",
        label: "Files shared with someone",
        value: NotificationSettings.fileSharedSomeoneEmail,
      },
      {
        id: "folderCreatedEmail",
        label: "New folder is created",
        value: NotificationSettings.folderCreatedEmail,
      },
      {
        id: "folderEditedEmail",
        label: "Folder is edited",
        value: NotificationSettings.folderEditedEmail,
      },
      {
        id: "folderDeletedEmail",
        label: "Folder is deleted",
        value: NotificationSettings.folderDeletedEmail,
      },
      {
        id: "folderArchivedEmail",
        label: "Folder is archived",
        value: NotificationSettings.folderArchivedEmail,
      },
      {
        id: "folderSharedMeEmail",
        label: "Folder is shared with me",
        value: NotificationSettings.folderSharedMeEmail,
      },
      {
        id: "folderSharedSomeoneEmail",
        label: "Folder is shared with someone",
        value: NotificationSettings.folderSharedSomeoneEmail,
      },
      {
        id: "dateReminderEmail",
        label: "Date reminders",
        value: NotificationSettings.dateReminderEmail,
      },
      {
        id: "noteAddedFileEmail",
        label: "Note(s) made in a File",
        value: NotificationSettings.noteAddedFileEmail,
      },
    ];
    let notificationSettings = [
      {
        id: "folderCreatedNotify",
        label: "New folder is created",
        value: NotificationSettings.folderCreatedNotify,
      },
      {
        id: "tagAddedNotify",
        label: "New tag is added",
        value: NotificationSettings.tagAddedNotify,
      },
      {
        id: "tagDeletedNotify",
        label: "Tag is deleted",
        value: NotificationSettings.tagDeletedNotify,
      },
      {
        id: "documentTemplateAddedNotify",
        label: "New document template is added",
        value: NotificationSettings.documentTemplateAddedNotify,
      },
      {
        id: "documentTemplateUpdatedNotify",
        label: "Document template is updated",
        value: NotificationSettings.documentTemplateUpdatedNotify,
      },
      {
        id: "documentTemplateDeactivatedNotify",
        label: "Document template is deactivated",
        value: NotificationSettings.documentTemplateDeactivatedNotify,
      },
      {
        id: "documentTemplateActivatedNotify",
        label: "Document template is activated",
        value: NotificationSettings.documentTemplateActivatedNotify,
      },
      {
        id: "documentTemplateDeletedNotify",
        label: "Document template is deleted",
        value: NotificationSettings.documentTemplateDeletedNotify,
      },
    ];

    this.setState({
      emailSettings,
      notificationSettings,
    });
  };

  checkSelectAllEmail = () => {
    let emailSelectAll = this.state.emailSelectAll;
    let countTrue = 0;
    this.state.emailSettings.map((item) => {
      if (item.value === true) {
        countTrue = countTrue + 1;
      }
      return true;
    });
    if (countTrue === this.state.emailSettings.length) {
      emailSelectAll = true;
    } else {
      emailSelectAll = false;
    }
    this.setState({ emailSelectAll });
  };

  checkSelectAllNotify = () => {
    let notifySelectAll = this.state.notifySelectAll;
    let countTrue = 0;
    this.state.notificationSettings.map((item) => {
      if (item.value === true) {
        countTrue = countTrue + 1;
      }
      return true;
    });
    if (countTrue === this.state.notificationSettings.length) {
      notifySelectAll = true;
    } else {
      notifySelectAll = false;
    }
    this.setState({ notifySelectAll });
  };

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query myNotificationSettings {
            myNotificationSettings {
              fileAddedEmail
              fileEditedEmail
              fileDeletedEmail
              fileArchivedEmail
              fileMovedEmail
              fileSharedMeEmail
              fileSharedSomeoneEmail
              folderCreatedEmail
              folderEditedEmail
              folderDeletedEmail
              folderArchivedEmail
              folderSharedMeEmail
              folderSharedSomeoneEmail
              dateReminderEmail
              noteAddedFileEmail
              folderCreatedNotify
              tagAddedNotify
              tagDeletedNotify
              documentTemplateAddedNotify
              documentTemplateUpdatedNotify
              documentTemplateDeactivatedNotify
              documentTemplateActivatedNotify
              documentTemplateDeletedNotify
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const NotificationSettings = result.data.myNotificationSettings;
        if (NotificationSettings.length === 1) {
          this.setValuesOfSettings(NotificationSettings[0]);
          this.checkSelectAllEmail();
          this.checkSelectAllNotify();
        } else {
          this.setState({ emailSettings: [], notificationSettings: [] });
        }
      })
      .catch((e) => {
        // Toast message
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });

    apolloClient
      .query({
        query: gql`
          query {
            me {
              username
              email
              firstName
              lastName
              profile {
                mobileNumber
                image
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        let data = result.data.me;

        if (data && data.email) {
          this.setState({
            userInformation: {
              profilePic: data.profile.image ? data.profile.image : null,
              firstName: data.firstName ? data.firstName : "",
              lastName: data.lastName ? data.lastName : "",
              email: data.email,
              mobileNo: data.profile.mobileNumber
                ? data.profile.mobileNumber
                : "",
            },
          });
        }
      })
      .catch(() => {});
  }

  changeNameAndMobileNoHandler = (obj) => {
    this.setState({
      userInformation: { ...this.state.userInformation, ...obj },
    });
  };

  setProfilePicHandler = (img) => {
    this.setState({
      userInformation: { ...this.state.userInformation, profilePic: img },
    });
  };

  // onPreferenceOptionChange = (e) => {
  //   console.log("prefrance", e.target.name, e.target.value);
  //   // hit backend to save the particular preference
  // };

  changeSettings = (e, id) => {
    const field = id.split(/(?=[A-Z])/).map((item) => item.toLowerCase());
    const notificationOption = field.join("_");
    const optionValue = e.target.checked;
    const variables = {
      notificationOption: notificationOption,
      optionValue: optionValue,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation changeNotificationSetting(
            $notificationOption: String!
            $optionValue: Boolean!
          ) {
            changeNotificationSetting(
              notificationOption: $notificationOption
              optionValue: $optionValue
            ) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const success = result.data.changeNotificationSetting.success;
        if (success) {
          const isEmail = id.includes("Email");
          let newSettings = isEmail
            ? [...this.state.emailSettings]
            : [...this.state.notificationSettings];
          for (let i = 0; i < newSettings.length; i++) {
            let optionObj = newSettings[i];
            if (optionObj.id === id) {
              optionObj.value = optionValue;
              break;
            }
          }

          this.checkSelectAllEmail();
          this.checkSelectAllNotify();

          isEmail
            ? this.setState({ emailSettings: newSettings })
            : this.setState({ notificationSettings: newSettings });
          // Toast message
          const title = "Success";
          const detail = "Setting changed successfully!";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        // Toast message
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  selectAll = (e, notificationType, optionValue) => {
    const variables = {
      notificationType: notificationType,
      optionValue: optionValue,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation selectAllSettings(
            $notificationType: String!
            $optionValue: Boolean!
          ) {
            selectAllSettings(
              notificationType: $notificationType
              optionValue: $optionValue
            ) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const success = result.data.selectAllSettings.success;
        if (success) {
          const isEmailUpdate = notificationType === "Email";
          let updatedSetting = isEmailUpdate
            ? [...this.state.emailSettings]
            : [...this.state.notificationSettings];

          updatedSetting.map((item) => (item.value = optionValue));

          isEmailUpdate
            ? this.setState({
                emailSettings: updatedSetting,
                emailSelectAll: optionValue,
              })
            : this.setState({
                notificationSettings: updatedSetting,
                notifySelectAll: optionValue,
              });

          // Toast message
          const title = "Success";
          const detail = "Setting changed successfully!";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        // Toast message
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  selectAllEmailHandler = (e) => {
    const emailSelectAll = !this.state.emailSelectAll;
    const notificationType = "Email";
    this.selectAll(e, notificationType, emailSelectAll);
  };

  selectAllNotifyHandler = (e) => {
    const notifySelectAll = !this.state.notifySelectAll;
    const notificationType = "Notify";
    this.selectAll(e, notificationType, notifySelectAll);
  };

  render() {
    return (
      <div className="mt-15 container-fluid user-profile-wrapper">
        <div className="user-profile-header">
          <h3 className="title">Profile</h3>
        </div>

        <div className="user-profile-body">
          <div className="left-part">
            <ProfileCard
              {...this.state.userInformation}
              changeNameAndMobileNoHandler={this.changeNameAndMobileNoHandler}
              setProfilePicHandler={this.setProfilePicHandler}
              {...this.props}
            />
          </div>

          <div className="right-part">
            {/* for future version */}
            {/* <div className="preferences">
              <h3>Preferences</h3>
              <div className="form-groups">
                <div className="form-group preferences-form-group row">
                  <div className="form-item col">
                    <label>Language</label>
                    <select
                      name="language"
                      onClick={this.onPreferenceOptionChange}
                    >
                      {this.state.preferences.languages.map((language) => (
                        <option key={language} value={language}>
                          {language}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-item col">
                    <label>Time Zone</label>
                    <select
                      name="timeZone"
                      onClick={this.onPreferenceOptionChange}
                    >
                      {this.state.preferences.timeZones.map((timeZone) => (
                        <option key={timeZone} value={timeZone}>
                          {timeZone}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-item col">
                    <label>Date Format</label>
                    <select
                      name="dateFormat"
                      onClick={this.onPreferenceOptionChange}
                    >
                      {this.state.preferences.dateFormat.map((dateFormat) => (
                        <option key={dateFormat} value={dateFormat}>
                          {dateFormat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="notification-settings">
              <h3>Notification Settings</h3>
              <div className="settings-options row">
                {this.state.emailSettings.length > 0 && (
                  <div className="email-options col">
                    <h3>Email Me When:</h3>
                    <div className="options">
                      <div className="option">
                        <input
                          type="checkbox"
                          id="emailSelectAll"
                          checked={this.state.emailSelectAll}
                          onChange={(event) =>
                            this.selectAllEmailHandler(event)
                          }
                        />
                        <label htmlFor="emailSelectAll">
                          Select all email settings
                        </label>
                      </div>

                      {this.state.emailSettings.map((optionObj, index) => (
                        <div className="option" key={optionObj.id}>
                          <input
                            type="checkbox"
                            id={`email${index}`}
                            checked={
                              this.state.emailSettings.filter(
                                (obj) => obj.label === optionObj.label
                              )[0].value
                            }
                            onChange={(e) =>
                              this.changeSettings(e, optionObj.id)
                            }
                          />
                          <label htmlFor={`email${index}`}>
                            {optionObj.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {this.state.notificationSettings.length > 0 && (
                  <div className="notification-options col">
                    <h3>Notify Me When:</h3>
                    <div className="options">
                      <div className="option">
                        <input
                          type="checkbox"
                          id="notifySelectAll"
                          checked={this.state.notifySelectAll}
                          onChange={(event) =>
                            this.selectAllNotifyHandler(event)
                          }
                        />
                        <label htmlFor="notifySelectAll">
                          Select all notify settings
                        </label>
                      </div>
                      {this.state.notificationSettings.map(
                        (optionObj, index) => (
                          <div className="option" key={index}>
                            <input
                              type="checkbox"
                              id={`notify${index}`}
                              checked={
                                this.state.notificationSettings.filter(
                                  (obj) => obj.label === optionObj.label
                                )[0].value
                              }
                              onChange={(e) =>
                                this.changeSettings(e, optionObj.id)
                              }
                            />
                            <label htmlFor={`notify${index}`}>
                              {optionObj.label}
                            </label>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
